import React from 'react';
import { ResponsiveImage } from './ResponsiveImage';
import { ArrowRight } from 'lucide-react';
import { heroContent } from '../data/mock';

const Hero = () => {
  return (
    <section className="relative min-h-[600px] lg:min-h-[700px] overflow-hidden">
      {/* Background Image with lazy loading */}
      <div className="absolute inset-0">
        <ResponsiveImage
          src={heroContent.heroImage}
          alt="Professionnels en réunion"
          className="w-full h-full object-cover object-[center_5%]"
          loading="eager"
          decoding="async"
          fetchPriority="high"
          data-testid="home-hero-image"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="max-w-2xl animate-fade-in-up">
          {/* Title */}
          <h1 data-testid="home-hero-title" className="text-4xl lg:text-5xl xl:text-6xl font-serif text-white leading-tight mb-6">
            {heroContent.title}
          </h1>

          {/* Subtitle */}
          <p data-testid="home-hero-subtitle" className="text-xl lg:text-2xl text-[#E30022] font-medium mb-4">
            {heroContent.subtitle}
          </p>

          {/* Description */}
          <p data-testid="home-hero-description" className="text-gray-200 text-lg mb-8 leading-relaxed">
            {heroContent.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href="/recrutement"
              data-testid="home-hero-recrutement-link"
              className="inline-flex items-center justify-center gap-2 bg-[#E30022] text-white px-8 py-4 rounded hover:bg-[#c7001d] transition-all duration-200 font-medium group hover-lift"
            >
              {heroContent.ctaEmployer}
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <a 
              href="/deposer-cv"
              data-testid="home-hero-cv-link"
              className="inline-flex items-center justify-center gap-2 bg-white text-gray-800 px-8 py-4 rounded hover:bg-gray-100 transition-all duration-200 font-medium group hover-lift"
            >
              {heroContent.ctaCandidat}
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
